export interface Tour {
  id: number;
  title: string;
  destination: string;
  country: string;
  duration: string;
  price: number;
  originalPrice?: number;
  rating: number;
  reviews: number;
  category: string;
  image: string;
  highlights: string[];
  tag?: string;
  inclusions: string[];
}

export const tours: Tour[] = [
  {
    id: 1,
    title: "Enchanting Bali & Nusa Penida",
    destination: "Bali, Indonesia",
    country: "Indonesia",
    duration: "6 Days 5 Nights",
    price: 2299,
    originalPrice: 2799,
    rating: 4.9,
    reviews: 148,
    category: "Southeast Asia",
    image: "https://public.readdy.ai/ai/img_res/35a426cf8a82905ffd7aeae44eab9926.jpg",
    highlights: ["Tanah Lot Temple Sunset", "Tegallalang Rice Terraces", "Nusa Penida Snorkeling", "Traditional Kecak Dance"],
    tag: "Best Seller",
    inclusions: ["Return Airfare", "5-Night Hotel", "Daily Breakfast", "Licensed Guide", "Airport Transfer"],
  },
  {
    id: 2,
    title: "Japan Cherry Blossom Escape",
    destination: "Tokyo & Kyoto, Japan",
    country: "Japan",
    duration: "8 Days 7 Nights",
    price: 4899,
    originalPrice: 5499,
    rating: 4.9,
    reviews: 213,
    category: "East Asia",
    image: "https://readdy.ai/api/search-image?query=Japan%20cherry%20blossom%20sakura%20trees%20full%20bloom%20pathway%20with%20Mount%20Fuji%20in%20background%2C%20pink%20flowers%2C%20clear%20blue%20sky%2C%20beautiful%20spring%20landscape%2C%20travel%20photography%2C%20vibrant%20colors&width=600&height=400&seq=1004&orientation=landscape",
    highlights: ["Mount Fuji Viewing", "Arashiyama Bamboo Grove", "Fushimi Inari Shrine", "Nishiki Market Food Tour"],
    tag: "Hot Pick",
    inclusions: ["Return Airfare", "7-Night Hotel", "Breakfast & Dinner", "JR Pass (7 Days)", "Licensed Guide"],
  },
  {
    id: 3,
    title: "Romantic Paris & Swiss Alps",
    destination: "Paris & Switzerland",
    country: "Europe",
    duration: "10 Days 9 Nights",
    price: 6799,
    originalPrice: 7499,
    rating: 4.8,
    reviews: 97,
    category: "Europe",
    image: "https://readdy.ai/api/search-image?query=Paris%20France%20Eiffel%20Tower%20at%20golden%20sunset%20with%20river%20Seine%20and%20flower%20gardens%2C%20romantic%20European%20cityscape%2C%20warm%20glowing%20light%2C%20beautiful%20travel%20destination%2C%20iconic%20landmark%20photography&width=600&height=400&seq=1005&orientation=landscape",
    highlights: ["Eiffel Tower Visit", "Louvre Museum", "Swiss Alps Train Ride", "Interlaken Activities"],
    tag: "Premium",
    inclusions: ["Return Airfare", "9-Night Hotel", "Daily Breakfast", "Euro Rail Pass", "City Tours"],
  },
  {
    id: 4,
    title: "Maldives Overwater Paradise",
    destination: "Maldives",
    country: "Maldives",
    duration: "5 Days 4 Nights",
    price: 5499,
    originalPrice: 6299,
    rating: 5.0,
    reviews: 76,
    category: "Indian Ocean",
    image: "https://readdy.ai/api/search-image?query=Maldives%20overwater%20bungalow%20resort%20with%20crystal%20clear%20turquoise%20lagoon%20and%20white%20sandy%20beach%2C%20tropical%20island%20paradise%2C%20bright%20sunny%20day%2C%20luxury%20travel%20destination%20aerial%20photography&width=600&height=400&seq=1006&orientation=landscape",
    highlights: ["Overwater Villa Stay", "Snorkeling & Diving", "Sunset Dolphin Cruise", "Private Beach Dining"],
    tag: "Luxury",
    inclusions: ["Return Airfare", "4-Night Overwater Villa", "Full Board Meals", "Speedboat Transfer", "Water Sports"],
  },
  {
    id: 5,
    title: "Korea Cultural Discovery",
    destination: "Seoul & Busan, Korea",
    country: "South Korea",
    duration: "7 Days 6 Nights",
    price: 3599,
    originalPrice: 3999,
    rating: 4.7,
    reviews: 162,
    category: "East Asia",
    image: "https://readdy.ai/api/search-image?query=Seoul%20South%20Korea%20Gyeongbokgung%20palace%20with%20autumn%20red%20orange%20maple%20foliage%20traditional%20architecture%20blue%20sky%2C%20vibrant%20travel%20destination%20photography&width=600&height=400&seq=1007&orientation=landscape",
    highlights: ["Gyeongbokgung Palace", "Jeju Island Day Trip", "N Seoul Tower", "Busan Haeundae Beach"],
    inclusions: ["Return Airfare", "6-Night Hotel", "Daily Breakfast", "T-Money Card", "Licensed Guide"],
  },
  {
    id: 6,
    title: "Istanbul & Cappadocia Wonder",
    destination: "Turkey",
    country: "Turkey",
    duration: "9 Days 8 Nights",
    price: 4299,
    originalPrice: 4999,
    rating: 4.8,
    reviews: 88,
    category: "Middle East",
    image: "https://readdy.ai/api/search-image?query=Cappadocia%20Turkey%20hot%20air%20balloons%20flying%20over%20fairy%20chimneys%20rocky%20landscape%20at%20sunrise%2C%20orange%20golden%20sky%2C%20magical%20travel%20destination%2C%20beautiful%20aerial%20scenery%20photography&width=600&height=400&seq=1008&orientation=landscape",
    highlights: ["Hot Air Balloon Ride", "Hagia Sophia Visit", "Grand Bazaar Shopping", "Whirling Dervish Show"],
    tag: "New",
    inclusions: ["Return Airfare", "8-Night Hotel", "Daily Breakfast", "Balloon Ride", "Licensed Guide"],
  },
  {
    id: 7,
    title: "Thailand Beach & Temple Tour",
    destination: "Bangkok & Phuket, Thailand",
    country: "Thailand",
    duration: "7 Days 6 Nights",
    price: 2799,
    originalPrice: 3299,
    rating: 4.7,
    reviews: 201,
    category: "Southeast Asia",
    image: "https://readdy.ai/api/search-image?query=Bangkok%20Thailand%20Wat%20Phra%20Kaew%20Grand%20Palace%20golden%20temple%20with%20lotus%20flower%20pond%20reflection%2C%20blue%20sky%20white%20clouds%2C%20stunning%20Thai%20architecture%20ornate%20detail%2C%20travel%20photography%20vibrant%20colors&width=600&height=400&seq=1011&orientation=landscape",
    highlights: ["Grand Palace Bangkok", "Phi Phi Islands Cruise", "Chiang Mai Elephant Sanctuary", "Floating Market"],
    inclusions: ["Return Airfare", "6-Night Hotel", "Daily Breakfast", "Island Hopping", "Licensed Guide"],
  },
  {
    id: 8,
    title: "Egypt & Nile Cruise Adventure",
    destination: "Cairo & Luxor, Egypt",
    country: "Egypt",
    duration: "10 Days 9 Nights",
    price: 5199,
    originalPrice: 5999,
    rating: 4.6,
    reviews: 54,
    category: "Middle East",
    image: "https://readdy.ai/api/search-image?query=Egypt%20pyramids%20of%20Giza%20with%20golden%20desert%20sand%20dunes%20and%20camel%20caravan%20at%20sunset%2C%20ancient%20wonder%20of%20the%20world%2C%20dramatic%20golden%20orange%20sky%2C%20travel%20photography%20historical%20landmark&width=600&height=400&seq=1012&orientation=landscape",
    highlights: ["Pyramids of Giza", "Nile River Cruise", "Valley of the Kings", "Abu Simbel Temples"],
    tag: "Adventure",
    inclusions: ["Return Airfare", "9-Night Hotel + Cruise Cabin", "Full Board", "Nile Cruise 3 Nights", "Licensed Guide"],
  },
];

export const categories = ["All", "Southeast Asia", "East Asia", "Europe", "Indian Ocean", "Middle East"];
